import { zetApi } from '@zet/network'

export type verifyCustomerOtpParams = {
  aadhaarNumber: string
}

const aadhaarXMLTriggerOTP = async ({
  aadhaarNumber,
}: {
  aadhaarNumber: string
}) => {
  const response = await zetApi.post(
    `/user/aadhaar-xml/otp?aadhaarNo=${aadhaarNumber}`
  )

  return response?.data
}

const aadhaarXMLDownload = async ({
  aadhaarNumber,
  otp,
}: {
  aadhaarNumber: string
  otp: string
}) => {
  const response = await zetApi.post(
    `/user/aadhaar-xml/download?aadhaarNo=${aadhaarNumber}&otp=${otp}`
  )

  return response?.data
}

const aadharDigilockerLink = async () => {
  const response = await zetApi.post(`/user/digilocker/link`)
  return response?.data
}

const aadhaarDigilockerFetchAddress = async ({
  accessRequestId,
}: {
  accessRequestId: string
}) => {
  const response = await zetApi.post('/user/digilocker/fetch-aadhaar-address', {
    accessRequestId,
  })
  return response?.data
}

export {
  aadhaarDigilockerFetchAddress,
  aadhaarXMLDownload,
  aadhaarXMLTriggerOTP,
  aadharDigilockerLink,
}
